export const GOVERNANCE_PROFILES = {
  foundation: {
    id: "foundation",
    name: "Foundation",
    description: "Essential governance for small organisations",
    governancePulse: "optional",
    boardChemistry: "optional",
    decisionOwner: "optional",
    voteRecord: "optional",
    boardTrainingLog: "optional",
    annualGovernanceReviewRequired: false,
    terminology: {
      decision: "Decision",
      meeting: "Meeting",
    },
  },
  standard: {
    id: "standard",
    name: "Standard",
    description: "Balanced governance for growing organisations",
    governancePulse: "recommended",
    boardChemistry: "recommended",
    decisionOwner: "strongly-recommended",
    voteRecord: "recommended",
    boardTrainingLog: "recommended",
    annualGovernanceReviewRequired: false,
    terminology: {
      decision: "Resolution",
      meeting: "Board Meeting",
    },
  },
  advanced: {
    id: "advanced",
    name: "Advanced",
    description: "Comprehensive governance for regulated organisations",
    governancePulse: "strongly-recommended",
    boardChemistry: "strongly-recommended",
    decisionOwner: "mandatory",
    voteRecord: "mandatory",
    boardTrainingLog: "strongly-recommended",
    annualGovernanceReviewRequired: true,
    terminology: {
      decision: "Resolution",
      meeting: "Board Meeting",
    },
  },
  elite: {
    id: "elite",
    name: "Elite",
    description:
      "Highest governance standards for listed or supervised organisations",
    governancePulse: "mandatory",
    boardChemistry: "mandatory",
    decisionOwner: "mandatory",
    voteRecord: "mandatory",
    boardTrainingLog: "mandatory",
    annualGovernanceReviewRequired: true,
    terminology: {
      decision: "Resolution",
      meeting: "Board Session",
    },
  },
};

export const ALL_PROFILES = Object.values(GOVERNANCE_PROFILES);

export const DEFAULT_PROFILE_ID = "standard";

export const getRequirementLabel = (level) => {
  switch (level) {
    case "mandatory":
      return "Mandatory";
    case "strongly-recommended":
      return "Strongly recommended";
    case "recommended":
      return "Recommended";
    case "optional":
      return "Optional";
    case "disabled":
      return "Disabled";
    case "hidden":
      return "Hidden";
    default:
      return level ?? "—";
  }
};
